export default {
  namespaced: true,
  state: {
    viewedEntityDialog: false,
    // viewedCreateEntityDialog: false,
    // viewedEditEntityDialog: false,
    entityId: null
  },
  mutations: {
    setEntityId: (state, payload) => {
      state.entityId = payload
    },
    setViewedEntityDialog: (state, display) => {
      state.viewedEntityDialog = display
    }
    // setViewedCreateEntityDialog: (state, payload) => {
    //   state.viewedCreateEntityDialog = payload
    // },
    // setViewedEditEntityDialog: (state, payload) => {
    //   state.viewedEditEntityDialog = payload
    // }
  },
  actions: {
  },
  getters: {
  }
}
